export function containsOrAfter(current: Node, node: Node): boolean {
	return (
		current.contains(node) ||
		// tslint:disable-next-line:no-bitwise
		!!(node.compareDocumentPosition(current) & Node.DOCUMENT_POSITION_PRECEDING)
	);
}
